export default __webpack_public_path__ + "static/media/VEN.0d453750.svg";